export const isValidPhone = (value?: string) => {
  if (!value) return false
  if (value.trim() === "") return false;
  if (!/[0-9]{10,}/.test(value)) return false;
  return true;
};

export const getPhoneValue = (value: string) => {
  const numberValue = value
    .replace(/\D/g, "")
    .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

  if (numberValue) return numberValue[0];
};

export const formatToPhone = (value: string) => {
  const input = value.replace(/\D/g, "").substring(0, 10);
  const areaCode = input.substring(0, 3);
  const middle = input.substring(3, 6);
  const last = input.substring(6, 10);

  let res = "";

  if (input.length > 6) {
    res = value = `(${areaCode}) ${middle} - ${last}`;
  } else if (input.length > 3) {
    res = value = `(${areaCode}) ${middle}`;
  } else if (input.length > 0) {
    res = value = `(${areaCode}`;
  }

  return res;
};
